import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ConsignmentLineAssignGet, ConsignmentLineAssignRow, ConsignmentLineAssignSaveParams, ConsignmentService } from '@app/services/consignment.service';

@Component({
  selector: 'tt-consignment-line-assign',
  templateUrl: './consignment-line-assign.component.html',
  styleUrls: ['./consignment-line-assign.component.css'],
  standalone: false,
})
export class ConsignmentLineAssignComponent implements OnInit {
    public page?: ConsignmentLineAssignGet;
    public grid?: GridOptions<ConsignmentLineAssignRow>;
    public loading = false;
    public saving = false;

    constructor(
        private consignment: ConsignmentService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        const keyno = this.navigator?.params['consignmentline_keyno'];
        if (typeof keyno !== 'string' && typeof keyno !== 'number') return;
        this.loading = true;
        try {
            this.page = await this.consignment.getLineAssignment({ consignmentline_keyno: keyno });
            if (!this.page) return;
            this.grid = new Grid<ConsignmentLineAssignRow>()
                .setRememberId('w_consignmentlineassign_stockbatch_grid')
                .setLoadDataFunction({ method: 3566, parameters: () => this.page })
                .setKendoConfig({ height: null, sortable: true, aggregate: true, pager: false, selectable: false, filterable: false });
        } finally {
            this.loading = false;
        }
    }

    public async saveChanges(): Promise<void> {
        const gridfunc = this.grid?.gridfunc;
        if (!this.page || !gridfunc || this.loading || this.saving) return;
        this.saving = true;
        try {
            gridfunc.getGridApi().stopEditing();
            const params: ConsignmentLineAssignSaveParams = {
                ...this.page,
                // Pick quantities determine inclusion, independently of grid row selection.
                records: gridfunc.getRows().filter((row) => row.quantity_pick_now !== 0),
            };
            const response = await this.consignment.saveLineAssignment(params);
            if (String(response?.errorcode) === '0') {
                await this.navigator?.back(undefined, params);
            } else {
                await this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: response?.errormessage ?? '' });
            }
        } finally {
            this.saving = false;
        }
    }

}
